// Copyright © Paladin Projects LLC, 2026

import { createContext } from "react";

export type TWindowWidth = 'smallMobile' | 'desktop' // | 'mobile' | 'tabletPortrait' | 'tabletAlbum'

export interface IAdaptivityContextValue {
    windowWidth: number;
    breakpoint: TWindowWidth;
}

export const AdaptivityContext = createContext<IAdaptivityContextValue | null>(null);